<template lang="pug">
.content(v-if="articleList.length > 0")
  .list-title PR Newswire
  ul.list-reset.content-list
    li.list-item(v-for="item, idx in articleList", :key="item.isoDate")
      a(:href="item.link", target="_blank")
        | {{ item.title }}

</template>

<script>
import _take from 'lodash/take'
import _get from 'lodash/get';
import parser from 'rss-parser-browser';

export default {
  data () {
    return {
      articleList: [],
    }
  },
  methods: {
     fetchFeed() {
      this.$axios.get('/rss-prnasia-1969.xml')
        .then(response => {
          const data = response.data;

          parser.parseString(data, (err, parsed) => {
            if (!err) this.articleList = _take(_get(parsed, 'feed.entries', []), 8);
          });

        })
    },
  },
  mounted () {
    this.fetchFeed();
  },

}
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';

.content
  border 1px solid #1f9ed3

.content-list
  padding 0 20px

.list-title
  padding 4px 10px
  color white
  background-color #1f9ed3

.list-item
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  a
    &:hover
      color #1f9ed3

  & + .list-item
    margin-top 10px
</style>





// WEBPACK FOOTER //
// RssNews.vue?0ff4d294